<ng-container [formGroupName]="controlKey">
  <div class="card">
    <h5 class="card-header text-center">SASSA information</h5>
    <div class="card-body">
      <table id="tblsalariedinfo" class="table table-striped table-sm mb-1">
        <colgroup>
          <col class="sassa-col-label" />
          <col class="sassa-col-control" />
          <col class="sassa-col-label" />
          <col class="sassa-col-control" />
        </colgroup>
        <tbody class="field-4column-label">
          <tr>
            <td>
              <label for="grantType">Type of grant</label>
            </td>
            <td>
              <mdb-select formControlName="grantType" (change)="toggleGrantType()" class="custom-select select table-control"
                [ngClass]="{ 'is-invalid': Submitted && grantType?.invalid }"
                placeholder="Grant Type *"
                required>
                <mdb-option *ngFor="let grantTypeOption of lstGrantTypes" [value]="grantTypeOption.value">
                  {{grantTypeOption.description}}
                </mdb-option>
              </mdb-select>
              <div *ngIf="grantType?.invalid && Submitted">
                <div *ngIf="grantType?.errors?.required">
                  <small class="text-danger ms-2">Grant type is required.</small>
                </div>
              </div>
            </td>
            <ng-container *ngIf="isGrantCategoryVisible(); then showCat else hideCate"></ng-container>
            <ng-template #showCat>
              <td>
                <label for="grantCategory">Grant category</label>
              </td>
              <td>
                <mdb-select formControlName="grantCategory" (change)="toggleGrantDates()" class="custom-select select table-control"
                  [ngClass]="{ 'is-invalid': Submitted && grantCategory?.enabled && grantCategory?.invalid }"
                  [required]="isGrantCategoryVisible()">
                  <mdb-option *ngFor="let grantCategoryOption of lstGrantCategories" [value]="grantCategoryOption.value">
                    {{grantCategoryOption.description}}
                  </mdb-option>
                </mdb-select>
                <div *ngIf="grantCategory?.enabled && grantCategory?.invalid && Submitted">
                  <small class="text-danger">Grant category is required.</small>
                </div>
              </td>
            </ng-template>
            <ng-template #hideCate>
              <td></td>
              <td></td>
            </ng-template>
          </tr>
          <!-- ALIASED as
                Temporary == Disability
                Permanent == Old age pension -->
          <ng-container *ngIf="!isGrantCategoryVisible() || grantCategory.value !== 'Temporary'; then showPermanent else showTemp">
          </ng-container>
          <ng-template #showPermanent>
            <tr>
              <td>
                <label for="grantStartDate">Grant Start Date</label>
              </td>
              <td>
                <div class="input-group input-group-sm" [ngClass]="{ 'is-invalid': Submitted && employmentStartDate?.enabled && employmentStartDate?.invalid }">
                  <input class="form-control grant-date-input" [mdbDatepicker]="grantStartDatePicker"
                    [max]="maxDate | date: 'yyyy-MM-dd'" placeholder="YYYY-MM-DD *"
                    formControlName="employmentStartDate" [required]="true" (change)="GrantDateSelected($event)"
                    [ngClass]="{ 'is-invalid': Submitted && employmentStartDate?.enabled && employmentStartDate?.invalid }"
                    (click)="grantStartDatePicker.toggle()" />
                  <div class="input-group-text">
                    <mdb-datepicker-toggle [mdbDatepicker]="grantStartDatePicker" icon="fas fa-calendar-alt" color="primary"></mdb-datepicker-toggle>
                    <mdb-datepicker #grantStartDatePicker [confirmDateOnSelect]="true" [format]="'yyyy-mm-dd'"></mdb-datepicker>
                  </div>
                </div>
                <div *ngIf="employmentStartDate?.invalid  || invalidDate">
                  <div *ngIf="employmentStartDate?.errors?.required && Submitted">
                    <small class="text-danger ms-2">Grant start date is required.</small>
                  </div>
                  <div *ngIf="invalidDate">
                    <small class="text-danger">{{payDateError}}</small>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <!-- GRANT START DATE and END DATE -->
          <!-- ALIASED as
                Temporary == Disability
                Permanent == Old age pension -->
          <ng-template #showTemp>
            <tr>
              <td *ngIf="grantCategory.value === 'Temporary'">
                <label>Temporary Start Date</label>
              </td>
              <td *ngIf="grantCategory.value === 'Temporary'">
                <div class="input-group input-group-sm" [ngClass]="{ 'is-invalid': Submitted && contractStartDate?.enabled && contractStartDate?.invalid }">
                  <input class="form-control grant-date-input" [mdbDatepicker]="temporaryStartDatePicker"
                    [max]="maxDate | date: 'yyyy-MM-dd'" placeholder="YYYY-MM-DD" formControlName="contractStartDate"
                    [required]="grantCategory.value === 'Temporary'" (change)="GrantDateSelected($event)"
                    [ngClass]="{ 'is-invalid': Submitted && contractStartDate?.enabled && contractStartDate?.invalid }"
                    (click)="temporaryStartDatePicker.toggle()" />
                  <div class="input-group-text">
                    <mdb-datepicker-toggle [mdbDatepicker]="temporaryStartDatePicker" icon="fas fa-calendar-alt" color="primary"></mdb-datepicker-toggle>
                    <mdb-datepicker #temporaryStartDatePicker [confirmDateOnSelect]="true" [format]="'yyyy-mm-dd'"></mdb-datepicker>
                  </div>
                </div>
                <div *ngIf="contractStartDate?.invalid  || invalidDate">
                  <div *ngIf="contractStartDate?.errors?.required && Submitted">
                    <small class="text-danger">Grant temporary start date is required</small>
                  </div>

                  <div *ngIf="invalidDate">
                    <small class="text-danger">{{payDateError}}</small>
                  </div>
                </div>
              </td>
              <td *ngIf="grantCategory.value === 'Temporary'">
                <label>Temporary End Date</label>
              </td>
              <!-- ALIASED as
                  Temporary == Disability
                  Permanent == Old age pension -->
              <td *ngIf="grantCategory.value === 'Temporary'">
                <div class="input-group input-group-sm" [ngClass]="{ 'is-invalid': Submitted && contractEndDate?.enabled && contractEndDate?.invalid }">
                  <input class="form-control grant-date-input" [mdbDatepicker]="temporaryEndDatePicker" placeholder="YYYY-MM-DD"
                    formControlName="contractEndDate" [required]="grantCategory.value === 'Temporary'"
                    [ngClass]="{ 'is-invalid': Submitted && contractEndDate?.enabled && contractEndDate?.invalid }"
                    (change)="GrantEndDateSelected($event)" (click)="temporaryEndDatePicker.toggle()" />
                  <div class="input-group-text">
                    <mdb-datepicker-toggle [mdbDatepicker]="temporaryEndDatePicker" icon="fas fa-calendar-alt" color="primary"></mdb-datepicker-toggle>
                    <mdb-datepicker #temporaryEndDatePicker [confirmDateOnSelect]="true" [format]="'yyyy-mm-dd'"></mdb-datepicker>
                  </div>
                </div>
                <div *ngIf="contractEndDate?.invalid">
                  <div *ngIf="contractEndDate?.errors?.required && Submitted">
                    <small class="text-danger">Grant temporary end date is required</small>
                  </div>
                </div>
                <div *ngIf="invalidEndDate">
                  <small class="text-danger">{{payDateError}}</small>
                </div>
              </td>
            </tr>
          </ng-template>
            <tr>
            <td>Latest grant amounts</td>
            <td colspan="4" class="py-1">
              <ng-container formGroupName="payslips">
                <span class="input-group d-flex align-items-center ms-auto">
                  <button class="btn btn-secondary me-5" (click)="openPaySlip(1)" mdbRipple>
                    {{(income1 === 0) ? 'Income 1' : income1 | zaRcurrency}}
                  </button>
                  <input hidden="true" [class.ng-invalid]="payslips!.hasError('duplicatePayslip')"
                    formControlName="payslip1" />

                  <button class="btn btn-secondary me-5" (click)="openPaySlip(2)" mdbRipple>
                    {{(income2 === 0) ? 'Income 2' : income2 | zaRcurrency}}
                  </button>
                  <input hidden="true" [class.ng-invalid]="payslips!.hasError('duplicatePayslip')"
                    formControlName="payslip2" />

                  <input hidden="true" [class.ng-invalid]="payslips!.hasError('duplicatePayslip')"
                    formControlName="payslip3" />
                  <button class="btn btn-secondary me-5" (click)="openPaySlip(3)" mdbRipple>
                    {{(income3 === 0) ? 'Income 3' : income3 | zaRcurrency}}
                  </button>
                </span>

                <div *ngIf="payslips?.invalid">
                  <div *ngIf="payslips!.hasError('duplicatePayslip')">
                    <small class="text-danger">
                      Duplicate payslip detected, this is not permitted!
                    </small>
                  </div>
                </div>
              </ng-container>
            </td>
          </tr>
          <tr *ngIf="Submitted && (income1 === 0 || income2 === 0 || income3 === 0)">
            <td></td>
            <td colspan="3">
              <small class="text-danger">
                At least 3 incomes needs to be captured.
              </small>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-container>
